// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3qBUB","item":"styles_item__2-kkQ","carousel":"styles_carousel__1iio5","image":"styles_image__VqZ6E"};